import React, { type ReactNode, type SyntheticEvent, useState } from 'react';

import { Breadcrumbs, Card, CardContent, Grid, Paper, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import DataContainer from './DataContainer';
import { DataDetailExports } from './DataDetailExports';
import { DataDetailReports } from './DataDetailReports';
import { DataProvider } from '../../../DataContext';
import StyledFormTitle from '../../../styles/form-title';

interface TabPanelProps {
    children?: ReactNode;
    dir?: string;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`class-detail-tabpanel-${index}`}
            aria-labelledby={`class-detail-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ mt: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `class-detail-tab-${index}`,
        'aria-controls': `class-detail-tabpanel-${index}`,
        value: index
    };
}

const Title = styled(StyledFormTitle)`
    margin-bottom: 1rem;
`;

export const DataDetail = () => {
    console.log('DataDetail');
    const { t } = useTranslation(['portal', 'create_edit_class']);
    const { dataData } = useContainer(DataContainer);
    const theme = useTheme();
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event: SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return (
        <>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <Title>{t('portal:classes-page.title')}</Title>
                </Grid>
            </Grid>

            <Breadcrumbs aria-label="breadcrumb">
                <Link to="/portal/classes">{t('portal:classes-page.all-classes')}</Link>
                <Typography color="text.primary">{dataData?.data_name}</Typography>
            </Breadcrumbs>

            <Paper elevation={0} sx={{ mt: 2 }}>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label={t('portal:classes-page.class-detail-tabs')}
                >
                    <Tab label={t('portal:datas.reports')} {...a11yProps(0)} />
                    <Tab label={t('portal:datas.exports')} {...a11yProps(1)} />
                </Tabs>
            </Paper>

            <TabPanel value={tabValue} index={0} dir={theme.direction}>
                <Card elevation={0} sx={{ overflow: 'visible', padding: 0 }}>
                    <CardContent>
                        {dataData && (
                            <DataProvider
                                dataId={dataData.data_id as unknown as string}
                                dataUuid={window.localStorage?.data_uuid as string}
                            >
                                <DataDetailReports />
                            </DataProvider>
                        )}
                    </CardContent>
                </Card>
            </TabPanel>
            <TabPanel value={tabValue} index={1} dir={theme.direction}>
                <Card elevation={0} sx={{ overflow: 'visible', padding: 0 }}>
                    <CardContent>
                        {dataData && (
                            <DataProvider
                                dataId={dataData.data_id as unknown as string}
                                dataUuid={window.localStorage?.data_uuid as string}
                            >
                                <DataDetailExports />
                            </DataProvider>
                        )}
                    </CardContent>
                </Card>
            </TabPanel>
        </>
    );
};
